var o = Function.prototype, n = o.toString;
function e(t) {
  if (t != null) {
    try {
      return n.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
export {
  e as default
};
